export default __webpack_public_path__ + "static/media/create.8e32d5d5.svg";